import { createSelector } from "reselect";

import getFilter from "../base_getters/get_filter";

const getMasterformatSelections = createSelector([
  getFilter
], (filter) => filter.masterFormats);

export default getMasterformatSelections;
